import React, { useEffect, useState } from 'react';

const RoomSection = () => {
  const [currentMobileIndex, setCurrentMobileIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const rooms = [
    {
      title: "Deluxe King Room",
      image: "/bbkandy/images/rooms/double.webp",
      link: "/BananaBunksKandy/room/kingroom",
      type: "1 King Bed",
      guests: "2 Guests"
    },
    {
      title: "Bed in 6-Bed Dormitory Room",
      image: "/bbkandy/images/rooms/bunks.webp",
      link: "/BananaBunksKandy/room/bedin6bed",
      type: "6 Bunk Beds",
      guests: "6 Guests"
    },
    {
      title: "Bed in 8-Bed Dormitory Room",
      image: "/bbkandy/images/rooms/bunks8.webp",
      link: "/BananaBunksKandy/room/bedin8bed",
      type: "8 Bunk Beds",
      guests: "8 Guests"
    },
    {
      title: "Deluxe Twin Room",
      image: "/bbkandy/images/rooms/twin.webp",
      link: "/BananaBunksKandy/room/twinroom",
      type: "2 Single Beds",
      guests: "2 Guests"
    }
  ];

  // Check if mobile on mount and resize
useEffect(() => {
  const checkIfMobile = () => {
    setIsMobile(window.innerWidth <= 1090 && window.innerHeight <= 790);
  };
  
  checkIfMobile();
  window.addEventListener('resize', checkIfMobile);
  return () => window.removeEventListener('resize', checkIfMobile);
}, []);

  // Auto-rotate mobile cards every 5 seconds
  useEffect(() => {
    if (!isMobile) return;
    
    const interval = setInterval(() => {
      setCurrentMobileIndex((prevIndex) => 
        prevIndex === rooms.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [rooms.length, isMobile]);

  const handlePrev = () => {
    setCurrentMobileIndex(prev => (prev === 0 ? rooms.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentMobileIndex(prev => (prev === rooms.length - 1 ? 0 : prev + 1));
  };

  const handleRoomHover = (e, hover) => {
    const imageLayer = e.currentTarget.querySelector('.image-layer');
    const capBox = e.currentTarget.querySelector('.cap-box');
    const hoverBox = e.currentTarget.querySelector('.hover-box');
    
    if (hover) {
      imageLayer.style.opacity = '1';
      imageLayer.style.transform = 'scale(1.1)';
      capBox.style.opacity = '0';
      capBox.style.transform = 'translateY(20px)';
      hoverBox.style.opacity = '1';
      hoverBox.style.transform = 'translateY(0)';
    } else {
      imageLayer.style.opacity = '0.8';
      imageLayer.style.transform = 'scale(1)';
      capBox.style.opacity = '1';
      capBox.style.transform = 'translateY(0)';
      hoverBox.style.opacity = '0';
      hoverBox.style.transform = 'translateY(-102%)';
    }
  };

  // Mobile carousel styles
  const mobileCarouselStyle = {
    position: "relative",
    maxWidth: "400px",
    margin: "0 auto",
    height: "600px",
    overflow: "hidden"
  };

  const mobileRoomCardStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    opacity: 0,
    transition: "opacity 0.5s ease-in-out",
    background: "white",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
  };

  const activeRoomCardStyle = {
    ...mobileRoomCardStyle,
    opacity: 1,
    zIndex: 1
  };

  // Desktop styles
  const roomBlockStyle = {
    position: "relative",
    zIndex: 2,
    overflow: "hidden",
    transition: "all 0.3s ease",
    marginBottom: "30px"
  };

  const imageLayerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    opacity: 0.8,
    transition: "all 0.5s ease"
  };

  const capBoxStyle = {
    position: "absolute",
    left: "30px",
    bottom: "30px",
    right: "30px",
    maxWidth: "350px",
    background: "#eeb85e",
    padding: "18px 20px 18px 40px",
    transition: "all 0.5s ease 0.2s"
  };

  const hoverBoxStyle = {
    position: "absolute",
    left: "30px",
    bottom: "30px",
    right: "30px",
    maxWidth: "350px",
    opacity: 0,
    transform: "translateY(-102%)",
    transition: "all 0.5s ease 0.2s"
  };

  const hoverBoxInnerStyle = {
    background: "#eeb85e",
    padding: "35px 40px 40px",
    color: "#3A4A26",
    borderRadius: "10px"
  };

  const checkAvailabilitySpanStyle = {
    fontSize: "16px",
    lineHeight: "30px",
    color: "#eeb85e",
    fontWeight: 500,
    padding: "15px 40px",
    background: "#3A4A26",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block"
  };

  return (
    <section style={{ backgroundColor: "#ffffff", padding: isMobile ? "40px 20px" : "0px 0" , backgroundImage: isMobile ? "url('/bbkandy/images/hotelbg/bbkandy.webp')" : ""}}>
      {/* Mobile View */}
      {isMobile && (
        <div >
          <div className='gdlr-core-title-item-title-wrap green_back_second' style={{ textAlign: "center", marginBottom: "30px" }}>
            <h3 style={{ 
              fontSize: "2.5rem",
              fontWeight: 500,
              color: "#3A4A26",
              marginBottom: "10px",
              fontFamily: "'Yellowtail', cursive"
            }}>
              Rooms & Bunks
            </h3>
            <div style={{ 
              fontSize: "1rem",
              color: "#3A4A26",
              fontFamily: "'Poppins', sans-serif"
            }}>
              Explore our range of accommodation
            </div>
          </div>

          <div style={mobileCarouselStyle}>
            {rooms.map((room, index) => (
              <div 
                key={index}
                style={index === currentMobileIndex ? activeRoomCardStyle : mobileRoomCardStyle}
              >
                <div style={{ height: "60%", backgroundImage: `url(${room.image})`, backgroundSize: "cover", backgroundPosition: "center", backgroundColor : "#EEB85F"}}></div>
                <div style={{ padding: "20px", height: "40%" , backgroundColor : "#EEB85F"}}>
                  <h3 style={{ 
                    fontSize: "24px",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    color: "#3A4A26",
                    marginBottom: "15px"
                  }}>
                    <a href={room.link} style={{ color: "inherit", textDecoration: "none" }}>
                      {room.title}
                    </a>
                  </h3>
                  <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                      <i className="gdlr-icon-double-bed2" style={{ marginRight: "8px" }}></i>
                      <span>{room.type}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i className="gdlr-icon-group" style={{ marginRight: "8px" }}></i>
                      <span>{room.guests}</span>
                    </div>
                  </div>
                  <a 
                    href={room.link}
                    style={{
                      display: "inline-block",
                      padding: "10px 20px",
                      backgroundColor: "#3A4A26",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: 500
                    }}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            ))}
            
            <div style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              marginTop: "20px"
            }}>
              <button 
                onClick={handlePrev}
                style={{
                  color: "#9e9e9e",
                  backgroundColor: "#f6f6f6",
                  padding: "12px",
                  borderRadius: "5px",
                  fontSize: "15px",
                  cursor: "pointer",
                  border: "none"
                }}
              >
                &lt;
              </button>
              <button 
                onClick={handleNext}
                style={{
                  color: "#9e9e9e",
                  backgroundColor: "#f6f6f6",
                  padding: "12px",
                  borderRadius: "5px",
                  fontSize: "15px",
                  cursor: "pointer",
                  border: "none"
                }}
              >
                &gt;
              </button>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <a 
              href="/BananaBunksKandy/room" 
              style={{
                display: "inline-block",
                fontSize: "18px",
                fontWeight: 500,
                letterSpacing: "0px",
                color: "#3A4A26",
                padding: "9px 33px",
                textTransform: "uppercase",
                borderRadius: "5px",
                backgroundColor: "#eeb85e",
                border: "2px solid #eeb85e",
                textDecoration: "none"
              }}
            >
              View All Rooms
            </a>
          </div>
        </div>
      )}

      {/* Desktop View */}
      {!isMobile && (
        <div className="outer-container bbkandybg desktopview" style={{
          padding: "140px 0",
          backgroundImage: "url('/bbkandy/images/hotelbg/bbkandy.webp')",
          backgroundSize: "cover"
        }}>
          <div style={{padding: "0px"}}>
            <div style={{textAlign: "center", marginBottom: "60px"}}>
              <div style={{
                backgroundColor: "#eeb85e",
                padding: "20px",
                marginBottom: "60px"
              }}>
                <h3 style={{
                  fontSize: "80px",
                  fontWeight: 500,
                  color: "#3A4A26",
                  fontFamily: "'Yellowtail', cursive",
                  margin: 0
                }}>
                  Rooms & Bunks
                </h3>
                <div style={{
                  fontSize: "18px",
                  lineHeight: "31px",
                  color: "#3A4A26",
                  marginTop: "20px"
                }}>Explore our range of accommodation</div>
              </div>
            </div>
          </div>

          <div style={{display: "flex", flexWrap: "wrap", margin: "0 -15px"}}>
            {/* Deluxe King Room */}
            <div style={{padding: "0 15px", flex: "0 0 33.333%", maxWidth: "33.333%"}}>
              <div 
                className="room-block" 
                style={{...roomBlockStyle, paddingLeft: '30px', height: "638px"}}
                onMouseEnter={(e) => handleRoomHover(e, true)}
                onMouseLeave={(e) => handleRoomHover(e, false)}
              >
                <div style={{position: "relative", display: "block", overflow: "hidden", transition: "all 0.3s ease"}}>
                  <div style={{position: "relative", background: "#171b27", height: "638px"}}>
                    <div 
                      className="image-layer"
                      style={{
                        ...imageLayerStyle,
                        backgroundImage: 'url(/bbkandy/images/rooms/double.webp)'
                      }}
                    ></div>
                    <img src="/bbkandy/images/rooms/double.webp" alt="Deluxe King Room" style={{display: "none", width: "100%", opacity: 0.8}} />
                  </div>
                  <div className="cap-box" style={capBoxStyle}>
                    <div>
                      <h5 style={{color: '#3A4A26', margin: 0}}>Deluxe King Room</h5>
                    </div>
                  </div>
                  <div className="hover-box" style={hoverBoxStyle}>
                    <div style={hoverBoxInnerStyle}>
                      <h4 style={{color: '#3A4A26', marginBottom: "15px"}}>Deluxe King Room</h4>
                      <div>
                        <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/kingroom" style={{display: "inline-block", textAlign: "center", transition: "all 0.3s ease", textDecoration: "none"}}>
                          <span style={checkAvailabilitySpanStyle}>Check Availability</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Dormitory Rooms Column */}
            <div style={{padding: "0 15px", flex: "0 0 33.333%", maxWidth: "33.333%"}}>
              {/* Bed in 6-Bed Dormitory Room */}
              <div 
                className="room-block" 
                style={{...roomBlockStyle, marginBottom: '16px', height: "311px"}}
                onMouseEnter={(e) => handleRoomHover(e, true)}
                onMouseLeave={(e) => handleRoomHover(e, false)}
              >
                <div style={{position: "relative", display: "block", overflow: "hidden", transition: "all 0.3s ease"}}>
                  <div style={{position: "relative", background: "#171b27", height: "311px"}}>
                    <div 
                      className="image-layer"
                      style={{
                        ...imageLayerStyle,
                        backgroundImage: 'url(/bbkandy/images/rooms/bunks.webp)'
                      }}
                    ></div>
                    <img src="/bbkandy/images/rooms/bunks.webp" alt="6-Bed Dormitory" style={{display: "none", width: "100%", opacity: 0.8}} />
                  </div>
                  <div className="cap-box" style={capBoxStyle}>
                    <div>
                      <h5 style={{color: '#3A4A26', margin: 0}}>Bed in 6-Bed Dormitory Room</h5>
                    </div>
                  </div>
                  <div className="hover-box" style={hoverBoxStyle}>
                    <div style={hoverBoxInnerStyle}>
                      <h4 style={{color: '#3A4A26', marginBottom: "15px"}}>Bed in 6-Bed Dormitory Room</h4>
                      <div>
                        <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/bedin6bed" style={{display: "inline-block", textAlign: "center", transition: "all 0.3s ease", textDecoration: "none"}}>
                          <span style={checkAvailabilitySpanStyle}>Check Availability</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bed in 8-Bed Dormitory Room */}
              <div 
                className="room-block" 
                style={{...roomBlockStyle, height: "311px"}}
                onMouseEnter={(e) => handleRoomHover(e, true)}
                onMouseLeave={(e) => handleRoomHover(e, false)}
              >
                <div style={{position: "relative", display: "block", overflow: "hidden", transition: "all 0.3s ease"}}>
                  <div style={{position: "relative", background: "#171b27", height: "311px"}}>
                    <div 
                      className="image-layer"
                      style={{
                        ...imageLayerStyle,
                        backgroundImage: 'url(/bbkandy/images/rooms/bunks8.webp)'
                      }}
                    ></div>
                    <img src="/bbkandy/images/rooms/bunks8.webp" alt="8-Bed Dormitory" style={{display: "none", width: "100%", opacity: 0.8}} />
                  </div>
                  <div className="cap-box" style={capBoxStyle}>
                    <div>
                      <h5 style={{color: '#3A4A26', margin: 0}}>Bed in 8-Bed Dormitory Room</h5>
                    </div>
                  </div>
                  <div className="hover-box" style={hoverBoxStyle}>
                    <div style={hoverBoxInnerStyle}>
                      <h4 style={{color: '#3A4A26', marginBottom: "15px"}}>Bed in 8-Bed Dormitory Room</h4>
                      <div>
                        <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/bedin8bed" style={{display: "inline-block", textAlign: "center", transition: "all 0.3s ease", textDecoration: "none"}}>
                          <span style={checkAvailabilitySpanStyle}>Check Availability</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Deluxe Twin Room */}
            <div style={{padding: "0 15px", flex: "0 0 33.333%", maxWidth: "33.333%"}}>
              <div 
                className="room-block" 
                style={{...roomBlockStyle, paddingRight: '30px', height: "638px"}}
                onMouseEnter={(e) => handleRoomHover(e, true)}
                onMouseLeave={(e) => handleRoomHover(e, false)}
              >
                <div style={{position: "relative", display: "block", overflow: "hidden", transition: "all 0.3s ease"}}>
                  <div style={{position: "relative", background: "#171b27", height: "638px"}}>
                    <div 
                      className="image-layer"
                      style={{
                        ...imageLayerStyle,
                        backgroundImage: 'url(/bbkandy/images/rooms/twin.webp)'
                      }}
                    ></div>
                    <img src="/bbkandy/images/rooms/twin.webp" alt="Deluxe Twin Room" style={{display: "none", width: "100%", opacity: 0.8}} />
                  </div>
                  <div className="cap-box" style={capBoxStyle}>
                    <div>
                      <h5 style={{color: '#3A4A26', margin: 0}}>Deluxe Twin Room</h5>
                    </div>
                  </div>
                  <div className="hover-box" style={hoverBoxStyle}>
                    <div style={hoverBoxInnerStyle}>
                      <h4 style={{color: '#3A4A26', marginBottom: "15px"}}>Deluxe Twin Room</h4>
                      <div>
                        <a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room/twinroom" style={{display: "inline-block", textAlign: "center", transition: "all 0.3s ease", textDecoration: "none"}}>
                          <span style={checkAvailabilitySpanStyle}>Check Availability</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <a 
  href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room" 
  style={{
    display: "inline-block",
    textAlign: "center",
    marginTop: isMobile ? "30px" : "60px",
    padding: isMobile ? "20px 0" : "40px 0",
    width: "100%"
  }}
>
  <span 
    className="gdlr-core-content green_back_second" 
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      fontSize: isMobile ? "18px" : "16px",
      fontWeight: 500,
      letterSpacing: "0px",
      color: "#3A4A26",
      padding: isMobile ? "12px 24px" : "15px 32px",
      textTransform: "uppercase",
      borderRadius: "5px",
      backgroundColor: "#eeb85e",
      border: "2px solid #3A4A26",
      textDecoration: "none",
      transition: "all 0.3s ease"
    }}
  >
    View All Rooms
    <i 
      className="gdlr-core-pos-right icon-arrow-right" 
      style={{
        fontSize: '16px', 
        verticalAlign: 'middle',  
        display: 'inline-block'
      }}
    ></i>
  </span>
</a>
        </div>
      )}
    </section>
  );
};

export default RoomSection;